import { FC, useContext } from "react";
import { IconBallFootball } from "@tabler/icons-react";
import { useDebouncedCurrentGame } from "../../../hooks/useDebouncedCurrentGame";
import { useShootoutDisplay } from "../../../hooks/useShootoutDisplay";
import { CompetitionContext } from "../../../CompetitionContext.tsx";
import { useTeam } from "../../../hooks/useTeam.ts";
import { getPresentationParamsForOrigin } from "../../../getPresentationParamsForOrigin.ts";

export const Shootout: FC = () => {
  const competitionId = useContext(CompetitionContext);
  const gameData = useDebouncedCurrentGame(competitionId);

  const homeTeam = useTeam(gameData.data?.actualTeams.homeTeamId);
  const guestTeam = useTeam(gameData.data?.actualTeams.guestTeamId);

  const shootout = useShootoutDisplay(gameData.data?.id);

  if (
    !gameData.isSuccess ||
    !homeTeam.isSuccess ||
    !guestTeam.isSuccess ||
    !shootout
  ) {
    return null;
  }

  const { homeShots, guestShots } = shootout;

  const homeTeamShots = homeShots.map((success, index) => (
    <IconBallFootball
      key={index}
      color={success !== null ? (success ? "#00e64d" : "red") : "#e8e8e8"}
      size={48}
    />
  ));

  const guestTeamShots = guestShots.map((success, index) => (
    <IconBallFootball
      key={index}
      color={success !== null ? (success ? "#00e64d" : "red") : "#e8e8e8"}
      size={48}
    />
  ));

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div
        style={{
          display: "inline-block",
          position: "relative",
          top: 900,
          fontFamily: "Chivo",
          fontWeight: 700,
          fontSize: 36,
          backgroundColor: "white",
          color: "black",
        }}
      >
        <div style={{ display: "flex" }}>
          <div
            style={{
              height: 80,
              display: "flex",
            }}
          >
            <div
              style={{
                borderLeftWidth: 12,
                borderLeftStyle: "solid",
                borderLeftColor: homeTeam.data.primaryColor,
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: 50,
                  height: 50,
                  marginLeft: 20,
                  marginRight: 30,
                  backgroundImage: `url(${homeTeam.data.logoFilePath})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                }}
              />
            </div>
            <div style={{ paddingTop: 17, display: "flex", gap: 15 }}>
              {homeTeamShots}
            </div>
          </div>
          <div
            style={{
              height: 80,
              width: 200,
              lineHeight: "80px",
              textAlign: "center",
              backgroundColor: getPresentationParamsForOrigin().colors.brand[9],
              color: "white",
              marginLeft: 60,
              marginRight: 60,
            }}
          >
            {
              gameData.data.shootOutShots.filter(
                (s) => s.teamId === homeTeam.data.id && s.success,
              ).length
            }
            –
            {
              gameData.data.shootOutShots.filter(
                (s) => s.teamId === guestTeam.data.id && s.success,
              ).length
            }
          </div>
          <div style={{ display: "flex" }}>
            <div
              style={{
                height: 80,
                display: "flex",
              }}
            >
              <div style={{ paddingTop: 17, display: "flex", gap: 15 }}>
                {guestTeamShots}
              </div>
              <div
                style={{
                  borderRightWidth: 12,
                  borderRightStyle: "solid",
                  borderRightColor: guestTeam.data.primaryColor,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    width: 50,
                    height: 50,
                    marginLeft: 30,
                    marginRight: 20,
                    backgroundImage: `url(${guestTeam.data.logoFilePath})`,
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
